import ManifestAcceptance from '@features/ManifestAcceptance/ui/ManifestAcceptance';

export default function ManifestAcceptancePage() {
  return <ManifestAcceptance />;
}
